import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { CommentsButton, CommentsContainer, CommentsWrapper } from './StowagePlanCommentsButton.style';

interface StowagePlanCommentsProps {
    stowagePlan: StowagePlan;
}

const StowagePlanCommentsButton: React.FC<StowagePlanCommentsProps> = ({ stowagePlan }) => {
    const [showComments, setShowComments] = React.useState(false);

    return (
        <CommentsWrapper id={`comments-${stowagePlan.stowagePlanGuid}`}>
            {stowagePlan.comments && (
                <CommentsButton onMouseEnter={() => setShowComments(true)} onMouseLeave={() => setShowComments(false)}>
                    <FontAwesomeIcon icon="comment" />
                </CommentsButton>
            )}
            {showComments && <CommentsContainer>{stowagePlan.comments ?? 'No comments...'}</CommentsContainer>}
        </CommentsWrapper>
    );
};

export default StowagePlanCommentsButton;
